import React from 'react';
import { Star, MessageSquareQuote, ArrowRight } from 'lucide-react';
import { PaymentIcons } from './PaymentIcons';
export function TestimonialsSection() {
  return <section className="w-full bg-teal-50 py-16 px-4" data-id="element-326">
      <div className="max-w-5xl mx-auto" data-id="element-327">
        <div className="flex items-center justify-center mb-10" data-id="element-328">
          <MessageSquareQuote size={32} className="text-teal-700 mr-3" data-id="element-329" />
          <h2 className="text-3xl font-bold text-gray-800" data-id="element-330">
            Real Transformation Stories
          </h2>
        </div>
        <p className="text-xl text-center text-gray-700 mb-12 max-w-3xl mx-auto" data-id="element-331">
          Thousands of people are already experiencing surprising results with
          our nutrition system
        </p>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-332">
          {/* Testimonio 1 */}
          <div className="bg-white rounded-lg shadow-lg p-6" data-id="element-333">
            <div className="flex text-orange-400 mb-4" data-id="element-334">
              {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="currentColor" data-id="element-335" />)}
            </div>
            <p className="text-gray-700 mb-6 italic" data-id="element-336">
              "After 3 weeks, my doctor couldn't believe the results. My
              cholesterol dropped 42 points and my blood sugar stabilized. All
              from my kitchen, without additional medications."
            </p>
            <div className="flex items-center" data-id="element-337">
              <div className="w-12 h-12 rounded-full overflow-hidden mr-4" data-id="element-338">
                <img src="https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80" alt="Mary L." className="w-full h-full object-cover" data-id="element-339" />
              </div>
              <div data-id="element-340">
                <p className="font-semibold text-gray-800" data-id="element-341">Mary L.</p>
                <p className="text-sm text-gray-600" data-id="element-342">56 years, Houston TX</p>
              </div>
            </div>
          </div>
          {/* Testimonio 2 */}
          <div className="bg-white rounded-lg shadow-lg p-6" data-id="element-343">
            <div className="flex text-orange-400 mb-4" data-id="element-344">
              {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="currentColor" data-id="element-345" />)}
            </div>
            <p className="text-gray-700 mb-6 italic" data-id="element-346">
              "My A1C went from 8.2 to 6.1 in just 8 weeks. My doctor asked what
              I was doing differently. I showed him this recipe book and now he
              recommends it to his patients."
            </p>
            <div className="flex items-center" data-id="element-347">
              <div className="w-12 h-12 rounded-full overflow-hidden mr-4" data-id="element-348">
                <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80" alt="John R." className="w-full h-full object-cover" data-id="element-349" />
              </div>
              <div data-id="element-350">
                <p className="font-semibold text-gray-800" data-id="element-351">John R.</p>
                <p className="text-sm text-gray-600" data-id="element-352">62 years, Miami FL</p>
              </div>
            </div>
          </div>
          {/* Testimonio 3 */}
          <div className="bg-white rounded-lg shadow-lg p-6" data-id="element-353">
            <div className="flex text-orange-400 mb-4" data-id="element-354">
              {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="currentColor" data-id="element-355" />)}
            </div>
            <p className="text-gray-700 mb-6 italic" data-id="element-356">
              "I had been taking statins for 5 years. In 30 days following these
              recipes, my doctor reduced my dose by half. For the first time, I
              feel like I have control over my health."
            </p>
            <div className="flex items-center" data-id="element-357">
              <div className="w-12 h-12 rounded-full overflow-hidden mr-4" data-id="element-358">
                <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80" alt="Sarah C." className="w-full h-full object-cover" data-id="element-359" />
              </div>
              <div data-id="element-360">
                <p className="font-semibold text-gray-800" data-id="element-361">Sarah C.</p>
                <p className="text-sm text-gray-600" data-id="element-362">48 years, Chicago IL</p>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-12 bg-teal-50 p-6 rounded-lg" data-id="element-363">
          <div className="flex items-start" data-id="element-364">
            <div className="bg-white p-2 rounded-full mr-4 flex-shrink-0" data-id="element-365">
              <Star size={24} className="text-teal-700" data-id="element-366" />
            </div>
            <p className="text-lg text-gray-700" data-id="element-367">
              <span className="font-semibold" data-id="element-368">98% satisfaction</span> among more
              than 5,000 people who have followed our method in the last 2
              years.
            </p>
          </div>
        </div>
        <div className="mt-12 text-center bg-white p-8 rounded-lg shadow-md" data-id="element-369">
          <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-370">
            Join These Success Stories Today
          </h3>
          <p className="text-lg text-gray-700 mb-6" data-id="element-371">
            Don't wait another day to start your health transformation. Get
            immediate access to our proven recipe system.
          </p>
          <a href="https://ebooksociety.co/cart/51407721562393:1?checkout" className="bg-orange-600 hover:bg-orange-700 text-white font-bold py-4 px-8 rounded-lg inline-flex items-center transition shadow-lg animate-subtle-pulse" data-id="element-372">
            Transform Your Health Now
            <ArrowRight size={20} className="ml-2" data-id="element-373" />
          </a>
          <div className="max-w-md mx-auto" data-id="element-374">
            <PaymentIcons data-id="element-375" />
          </div>
          <p className="text-sm text-gray-500 mt-4" data-id="element-376">
            Limited time offer: $19 USD (Regular price: $39 USD)
          </p>
        </div>
        <div className="mt-16" data-id="element-377">
          <div className="rounded-lg overflow-hidden shadow-lg" data-id="element-378">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6puZefPN5mmxFK33Sg83dx/Generated_Image_September_22%2C_2025_-_9_41PM.webp" alt="People reading Eat To Heal in a bookstore" className="w-full h-auto" data-id="element-379" />
          </div>
          <p className="text-center text-gray-700 mt-4 font-medium" data-id="element-380">
            Join thousands of readers who are transforming their health with Eat
            To Heal
          </p>
        </div>
      </div>
      <style jsx data-id="element-381">{`
        @keyframes subtlePulse {
          0%,
          100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.03);
          }
        }
        .animate-subtle-pulse {
          animation: subtlePulse 3s infinite ease-in-out;
        }
      `}</style>
    </section>;
}